// components/student/Wishlist.js
import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import ReactDOM from "react-dom";
import MyStudentLayout from "./../../../layouts/Student/MyStudentLayout";
import "../../../assets/css/student/Wishlist.css";

// ─── SVG ICONS ────────────────────────────────────────────────────────────────
const Icon = {
  List: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/>
      <line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
    </svg>
  ),
  Grid: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
      <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
    </svg>
  ),
  Focus: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="8" height="18" rx="1"/><rect x="14" y="3" width="8" height="18" rx="1"/>
    </svg>
  ),
  Star: ({ filled }) => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill={filled ? "#f59e0b" : "none"} stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  ),
  Trash: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
      <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
    </svg>
  ),
  Play: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none">
      <polygon points="5 3 19 12 5 21 5 3"/>
    </svg>
  ),
  ChevronRight: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  ),
  ChevronDown: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  ),
  Brain: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.46 2.5 2.5 0 0 1-1.75-4.34A3 3 0 0 1 4.5 9.5a3 3 0 0 1 .44-1.57 2.5 2.5 0 0 1 .31-4.43A2.5 2.5 0 0 1 9.5 2z"/>
      <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.46 2.5 2.5 0 0 0 1.75-4.34A3 3 0 0 0 19.5 9.5a3 3 0 0 0-.44-1.57 2.5 2.5 0 0 0-.31-4.43A2.5 2.5 0 0 0 14.5 2z"/>
    </svg>
  ),
  Clock: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  Zap: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>
  ),
  Flame: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>
    </svg>
  ),
  Map: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
      <line x1="9" y1="3" x2="9" y2="18"/><line x1="15" y1="6" x2="15" y2="21"/>
    </svg>
  ),
  Search: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  ),
  Filter: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
    </svg>
  ),
  Close: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
  Users: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  Award: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
    </svg>
  ),
  Book: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    </svg>
  ),
  Priority: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  ),
  Later: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  Maybe: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  ),
  Sparkle: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l1.88 5.47L19 9l-5.12 3.35L15.76 18 12 14.8 8.24 18l1.88-5.65L4 9l5.12-.53z"/>
    </svg>
  ),
  ExternalLink: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
      <polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>
    </svg>
  ),
};

// ─── MOCK DATA ─────────────────────────────────────────────────────────────────
const WISHLIST_DATA = [
  {
    id: 1,
    title: "Advanced React Patterns & Architecture",
    instructor: "Kent C. Dodds",
    rating: 4.9,
    reviewCount: 12400,
    level: "Advanced",
    duration: "24h 30m",
    lectures: 142,
    tags: ["React", "TypeScript", "Architecture"],
    price: "$84.99",
    savedDaysAgo: 2,
    priority: "high",
    enrolled: false,
    partialProgress: 0,
    aiInsight: "Matches your React roadmap",
    aiReason: "trending",
    matchScore: 96,
    description: "Master advanced React patterns including compound components, render props, custom hooks, and state management architectures used in large-scale production apps.",
    curriculum: [
      "Compound Component Pattern",
      "Render Props & HOCs",
      "Custom Hook Architecture",
      "State Machines with XState",
      "Performance Optimization Deep Dive",
    ],
    whyRecommended: "Based on your 65% completion of 'Complete Web Development', this course closes your React knowledge gap and pushes you to production-level skills.",
    accentColor: "#2563eb",
    bannerGradient: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 60%, #3b82f6 100%)",
  },
  {
    id: 2,
    title: "System Design for Frontend Engineers",
    instructor: "Alex Xu",
    rating: 4.8,
    reviewCount: 8920,
    level: "Intermediate",
    duration: "18h 15m",
    lectures: 98,
    tags: ["System Design", "Scalability", "Interviews"],
    price: "$69.99",
    savedDaysAgo: 7,
    priority: "later",
    enrolled: false,
    partialProgress: 12,
    aiInsight: "Trending in your interest",
    aiReason: "trending",
    matchScore: 82,
    description: "Learn to design large-scale frontend systems. Covers micro-frontends, CDN strategies, real-time systems, and performance at scale.",
    curriculum: [
      "Micro-frontend Architecture",
      "CDN & Edge Computing",
      "Real-time System Design",
      "Caching Strategies",
      "Interview Deep Dives",
    ],
    whyRecommended: "This aligns with your goal of senior engineering roles. 847 students with your profile enrolled this month.",
    accentColor: "#7c3aed",
    bannerGradient: "linear-gradient(135deg, #4c1d95 0%, #7c3aed 60%, #a78bfa 100%)",
  },
  {
    id: 3,
    title: "Node.js Microservices with Docker & Kubernetes",
    instructor: "Stephen Grider",
    rating: 4.7,
    reviewCount: 15600,
    level: "Intermediate",
    duration: "31h 45m",
    lectures: 210,
    tags: ["Node.js", "Docker", "K8s", "Microservices"],
    price: "$94.99",
    savedDaysAgo: 14,
    priority: "maybe",
    enrolled: false,
    partialProgress: 0,
    aiInsight: "Completes your backend path",
    aiReason: "roadmap",
    matchScore: 74,
    description: "Build production-grade microservices using Node.js, Docker, and Kubernetes. Deploy to AWS with CI/CD pipelines.",
    curriculum: [
      "Microservices Fundamentals",
      "Docker Containerization",
      "Kubernetes Orchestration",
      "Event-Driven Architecture",
      "CI/CD with GitHub Actions",
    ],
    whyRecommended: "You completed 'Node.js & REST APIs' at 100%. This is the natural next step toward backend mastery.",
    accentColor: "#16a34a",
    bannerGradient: "linear-gradient(135deg, #14532d 0%, #16a34a 60%, #4ade80 100%)",
  },
  {
    id: 4,
    title: "TypeScript: The Complete Developer's Guide",
    instructor: "Stephen Grider",
    rating: 4.8,
    reviewCount: 22100,
    level: "Beginner",
    duration: "27h 20m",
    lectures: 189,
    tags: ["TypeScript", "JavaScript", "OOP"],
    price: "$74.99",
    savedDaysAgo: 21,
    priority: "high",
    enrolled: false,
    partialProgress: 35,
    aiInsight: "Based on your JS progress",
    aiReason: "progress",
    matchScore: 91,
    description: "From JavaScript fundamentals to enterprise TypeScript. Covers generics, decorators, and integrating TS into React and Node projects.",
    curriculum: [
      "TypeScript Fundamentals",
      "Generics & Decorators",
      "TypeScript + React",
      "TypeScript + Express",
      "Advanced Types & Utility Types",
    ],
    whyRecommended: "Your 'Advanced JavaScript' course is 40% complete. TypeScript is the direct upgrade path for your skillset.",
    accentColor: "#ea580c",
    bannerGradient: "linear-gradient(135deg, #7c2d12 0%, #ea580c 60%, #fb923c 100%)",
  },
];

const PRIORITY_CONFIG = {
  high:  { label: "High Priority", Icon: Icon.Priority, cls: "priority--high" },
  later: { label: "Later",         Icon: Icon.Later,    cls: "priority--later" },
  maybe: { label: "Maybe",         Icon: Icon.Maybe,    cls: "priority--maybe" },
};

const AI_REASON_CONFIG = {
  trending: { Icon: Icon.Flame,  label: "Trending",        cls: "ai-reason--trending" },
  roadmap:  { Icon: Icon.Map,    label: "Roadmap fit",     cls: "ai-reason--roadmap"  },
  progress: { Icon: Icon.Zap,    label: "Based on progress", cls: "ai-reason--progress"},
};

// ─── HELPERS ───────────────────────────────────────────────────────────────────
function StarRating({ rating }) {
  return (
    <span className="star-rating">
      {[1,2,3,4,5].map(i => (
        <Icon.Star key={i} filled={i <= Math.round(rating)} />
      ))}
      <span className="star-rating__num">{rating}</span>
    </span>
  );
}

function LevelBadge({ level }) {
  return <span className={`level-badge level-badge--${level.toLowerCase()}`}>{level}</span>;
}

function PriorityTag({ priority, onChange }) {
  const cfg = PRIORITY_CONFIG[priority];
  const [open, setOpen] = useState(false);
  return (
    <div className="priority-tag-wrap">
      <button className={`priority-tag ${cfg.cls}`} onClick={() => setOpen(o => !o)}>
        <cfg.Icon />{cfg.label}<Icon.ChevronDown />
      </button>
      {open && (
        <div className="priority-dropdown">
          {Object.entries(PRIORITY_CONFIG).map(([key, c]) => (
            <button key={key} className={`priority-option ${c.cls}`} onClick={() => { onChange(key); setOpen(false); }}>
              <c.Icon />{c.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function AiChip({ reason, insight }) {
  const cfg = AI_REASON_CONFIG[reason] || AI_REASON_CONFIG.trending;
  return (
    <span className={`ai-chip ${cfg.cls}`}>
      <cfg.Icon />{insight}
    </span>
  );
}

function SavedAgo({ days }) {
  const text = days === 0 ? "Saved today"
    : days === 1 ? "Saved yesterday"
    : `Saved ${days} days ago`;
  return (
    <span className="saved-ago"><Icon.Clock />{text}</span>
  );
}

function TagList({ tags, max = 3 }) {
  return (
    <div className="tag-list">
      {tags.slice(0, max).map(t => <span key={t} className="tag">{t}</span>)}
    </div>
  );
}

// ─── PORTAL MODAL ROOT ────────────────────────────────────────────────────────
function getModalRoot() {
  let el = document.getElementById("wl-modal-root");
  if (!el) {
    el = document.createElement("div");
    el.id = "wl-modal-root";
    el.setAttribute("style", [
      "position:fixed","top:0","left:0",
      "width:100vw","height:100vh",
      "z-index:2147483647","pointer-events:none","isolation:isolate",
    ].join(";"));
    document.body.appendChild(el);
  }
  return el;
}

// ─── PREVIEW PANEL ─────────────────────────────────────────────────────────────
function PreviewPanel({ course, onClose, onRemove, asModal = false }) {
  const [portalRoot, setPortalRoot] = useState(null);
  useEffect(() => { if (asModal) setPortalRoot(getModalRoot()); }, [asModal]);
  useEffect(() => {
    if (!asModal || !course) return;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, [asModal, course]);

  if (!course) return null;

  const panel = (
    <div className={asModal ? "preview-modal-overlay" : "preview-panel"} onClick={asModal ? onClose : undefined} style={asModal ? { pointerEvents: "all" } : {}}>
      <div className={asModal ? "preview-modal-box" : "preview-panel__inner"} onClick={asModal ? e => e.stopPropagation() : undefined}>
        {/* Banner */}
        <div className="preview-panel__banner" style={{ background: course.bannerGradient }}>
          <button className="preview-panel__close-btn" onClick={onClose}><Icon.Close /></button>
          <div className="preview-panel__banner-content">
            <LevelBadge level={course.level} />
            <h2 className="preview-panel__title">{course.title}</h2>
            <p className="preview-panel__instructor"><Icon.Users />{course.instructor}</p>
          </div>
        </div>

        <div className="preview-panel__body">
          {/* Rating + meta */}
          <div className="preview-panel__meta">
            <StarRating rating={course.rating} />
            <span className="preview-panel__meta-item">({course.reviewCount.toLocaleString()} reviews)</span>
            <span className="preview-panel__divider" />
            <span className="preview-panel__meta-item"><Icon.Book />{course.lectures} lectures</span>
            <span className="preview-panel__meta-item"><Icon.Clock />{course.duration}</span>
          </div>

          {/* AI Insight */}
          <div className="preview-panel__ai-block">
            <div className="preview-panel__ai-header">
              <Icon.Brain /><span>Why recommended for you</span>
            </div>
            <p className="preview-panel__ai-text">{course.whyRecommended}</p>
            <div className="preview-panel__match">
              <span className="preview-panel__match-label">Match score</span>
              <div className="preview-panel__match-bar">
                <div className="preview-panel__match-fill" style={{ width: `${course.matchScore}%`, background: course.accentColor }} />
              </div>
              <span className="preview-panel__match-pct" style={{ color: course.accentColor }}>{course.matchScore}%</span>
            </div>
          </div>

          {/* Description */}
          <div className="preview-panel__section">
            <h4 className="preview-panel__section-title">About this course</h4>
            <p className="preview-panel__description">{course.description}</p>
          </div>

          {/* Curriculum */}
          <div className="preview-panel__section">
            <h4 className="preview-panel__section-title">Curriculum preview</h4>
            <ul className="preview-panel__curriculum">
              {course.curriculum.map((item, i) => (
                <li key={i} className="preview-panel__curriculum-item">
                  <span className="preview-panel__curriculum-num">{String(i + 1).padStart(2, "0")}</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Tags */}
          <TagList tags={course.tags} max={6} />

          {/* CTAs */}
          <div className="preview-panel__ctas">
            <button className="wl-btn wl-btn--primary" style={{ background: course.accentColor }}>
              <Icon.Play />Enroll Now — {course.price}
            </button>
            <button className="wl-btn wl-btn--outline">
              <Icon.ExternalLink />Preview Course
            </button>
          </div>

          {/* Remove */}
          <button className="preview-panel__remove-btn" onClick={() => onRemove(course.id)}>
            <Icon.Trash />Remove from wishlist
          </button>
        </div>
      </div>
    </div>
  );

  if (asModal && portalRoot) return ReactDOM.createPortal(panel, portalRoot);
  if (asModal) return null;
  return panel;
}

// ─── LIST ROW ──────────────────────────────────────────────────────────────────
function WishlistRow({ course, selected, onSelect, onRemove, onPriorityChange }) {
  return (
    <div
      className={`wl-row ${selected ? "wl-row--selected" : ""}`}
      onClick={() => onSelect(course)}
      style={{ "--accent": course.accentColor }}
    >
      <div className="wl-row__accent-bar" />

      <div className="wl-row__main">
        <div className="wl-row__top">
          <div className="wl-row__title-group">
            <h3 className="wl-row__title">{course.title}</h3>
            <div className="wl-row__badges">
              <LevelBadge level={course.level} />
              <AiChip reason={course.aiReason} insight={course.aiInsight} />
            </div>
          </div>
          <div className="wl-row__actions" onClick={e => e.stopPropagation()}>
            <PriorityTag priority={course.priority} onChange={v => onPriorityChange(course.id, v)} />
            <button className="wl-btn wl-btn--ghost wl-btn--sm" onClick={() => onRemove(course.id)}>
              <Icon.Trash />
            </button>
            <button className="wl-btn wl-btn--primary wl-btn--sm" style={{ background: course.accentColor }}>
              <Icon.Play />Enroll
            </button>
          </div>
        </div>

        <div className="wl-row__bottom">
          <span className="wl-row__instructor"><Icon.Users />{course.instructor}</span>
          <StarRating rating={course.rating} />
          <TagList tags={course.tags} max={3} />
          <SavedAgo days={course.savedDaysAgo} />
        </div>

        {course.partialProgress > 0 && (
          <div className="wl-row__progress">
            <div className="wl-row__progress-bar">
              <div className="wl-row__progress-fill" style={{ width: `${course.partialProgress}%`, background: course.accentColor }} />
            </div>
            <span className="wl-row__progress-text">{course.partialProgress}% started</span>
          </div>
        )}
      </div>

      <div className="wl-row__chevron"><Icon.ChevronRight /></div>
    </div>
  );
}

// ─── GRID CARD ─────────────────────────────────────────────────────────────────
function WishlistCard({ course, onSelect, onRemove, onPriorityChange }) {
  return (
    <div className="wl-card" style={{ "--accent": course.accentColor }} onClick={() => onSelect(course)}>
      {/* Banner */}
      <div className="wl-card__banner" style={{ background: course.bannerGradient }}>
        <div className="wl-card__banner-overlay" />
        <div className="wl-card__banner-top">
          <LevelBadge level={course.level} />
          <div onClick={e => e.stopPropagation()}>
            <PriorityTag priority={course.priority} onChange={v => onPriorityChange(course.id, v)} />
          </div>
        </div>
        <div className="wl-card__banner-actions" onClick={e => e.stopPropagation()}>
          <button className="wl-card__icon-btn" onClick={() => onRemove(course.id)} title="Remove">
            <Icon.Trash />
          </button>
        </div>
      </div>

      {/* Body */}
      <div className="wl-card__body">
        <AiChip reason={course.aiReason} insight={course.aiInsight} />
        <h3 className="wl-card__title">{course.title}</h3>
        <p className="wl-card__instructor"><Icon.Users />{course.instructor}</p>

        <div className="wl-card__stats">
          <StarRating rating={course.rating} />
          <span className="wl-card__reviews">({course.reviewCount.toLocaleString()})</span>
        </div>

        <TagList tags={course.tags} max={3} />

        {course.partialProgress > 0 && (
          <div className="wl-card__progress">
            <div className="wl-card__progress-bar">
              <div className="wl-card__progress-fill" style={{ width: `${course.partialProgress}%`, background: course.accentColor }} />
            </div>
            <span className="wl-card__progress-text">{course.partialProgress}% started</span>
          </div>
        )}

        <div className="wl-card__footer">
          <SavedAgo days={course.savedDaysAgo} />
          <button
            className="wl-btn wl-btn--primary wl-btn--sm"
            style={{ background: course.accentColor }}
            onClick={e => { e.stopPropagation(); }}
          >
            <Icon.Play />Start Learning
          </button>
        </div>
      </div>

      <div className="wl-card__match-indicator" style={{ background: course.accentColor }} title={`${course.matchScore}% match`}>
        <Icon.Sparkle />{course.matchScore}%
      </div>
    </div>
  );
}

// ─── VIEW SWITCHER ─────────────────────────────────────────────────────────────
function ViewSwitcher({ view, onChange }) {
  const views = [
    { id: "list",  label: "List",  Ic: Icon.List  },
    { id: "grid",  label: "Grid",  Ic: Icon.Grid  },
    { id: "focus", label: "Focus", Ic: Icon.Focus },
  ];
  return (
    <div className="view-switcher">
      {views.map(v => (
        <button
          key={v.id}
          className={`view-switcher__btn ${view === v.id ? "view-switcher__btn--active" : ""}`}
          onClick={() => onChange(v.id)}
        >
          <v.Ic />{v.label}
        </button>
      ))}
    </div>
  );
}

// ─── EMPTY STATE ───────────────────────────────────────────────────────────────
function EmptyState() {
  return (
    <div className="wl-empty">
      <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
        <circle cx="40" cy="40" r="38" stroke="#e0d5c7" strokeWidth="2"/>
        <path d="M28 30h24M28 38h16M28 46h20" stroke="#c4b5ab" strokeWidth="2.5" strokeLinecap="round"/>
        <circle cx="54" cy="52" r="10" fill="#faf8f5" stroke="#781c2e" strokeWidth="1.5" strokeOpacity=".4"/>
        <path d="M50.5 52h7M54 48.5v7" stroke="#781c2e" strokeWidth="1.5" strokeLinecap="round" strokeOpacity=".5"/>
      </svg>
      <h3 className="wl-empty__title">Your wishlist is empty</h3>
      <p className="wl-empty__sub">Browse courses and save the ones you want to learn next</p>
      <button className="wl-btn wl-btn--primary wl-btn--md" style={{ background: "#781c2e" }}>
        <Icon.Search />Explore Courses
      </button>
    </div>
  );
}

// ─── MAIN COMPONENT ────────────────────────────────────────────────────────────
export default function Wishlist() {
  const [view, setView] = useState("list");
  const [courses, setCourses] = useState(WISHLIST_DATA);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState("");
  const [filterLevel, setFilterLevel] = useState("all");
  const [filterPriority, setFilterPriority] = useState("all");
  const [sortBy, setSortBy] = useState("saved");
  const [showFilters, setShowFilters] = useState(false);

  const avgMatch = useMemo(() =>
    Math.round(courses.reduce((a, c) => a + c.matchScore, 0) / (courses.length || 1)),
    [courses]
  );

  const filtered = useMemo(() => {
    let list = courses.filter(c => {
      const q = search.toLowerCase();
      const matchSearch = !q || c.title.toLowerCase().includes(q) || c.instructor.toLowerCase().includes(q) || c.tags.some(t => t.toLowerCase().includes(q));
      const matchLevel = filterLevel === "all" || c.level.toLowerCase() === filterLevel;
      const matchPriority = filterPriority === "all" || c.priority === filterPriority;
      return matchSearch && matchLevel && matchPriority;
    });
    if (sortBy === "saved")   list = [...list].sort((a, b) => a.savedDaysAgo - b.savedDaysAgo);
    if (sortBy === "rating")  list = [...list].sort((a, b) => b.rating - a.rating);
    if (sortBy === "match")   list = [...list].sort((a, b) => b.matchScore - a.matchScore);
    if (sortBy === "priority") {
      const ord = { high: 0, later: 1, maybe: 2 };
      list = [...list].sort((a, b) => ord[a.priority] - ord[b.priority]);
    }
    return list;
  }, [courses, search, filterLevel, filterPriority, sortBy]);

  const handleRemove = useCallback((id) => {
    setCourses(prev => prev.filter(c => c.id !== id));
    if (selected?.id === id) setSelected(null);
  }, [selected]);

  const handlePriorityChange = useCallback((id, priority) => {
    setCourses(prev => prev.map(c => c.id === id ? { ...c, priority } : c));
  }, []);

  const handleSelect = useCallback((course) => {
    if (view === "grid") {
      setSelected(course);
    } else if (view === "list") {
      setView("focus");
      setSelected(course);
    } else {
      setSelected(course);
    }
  }, [view]);

  // In focus view, auto-select first item
  useEffect(() => {
    if (view === "focus" && !selected && filtered.length > 0) {
      setSelected(filtered[0]);
    }
  }, [view, filtered, selected]);

  return (
    <MyStudentLayout>
      <div className="wl-root">

        {/* ── PAGE HEADER ─────────────────────────────────────────────── */}
        <div className="wl-header">
          <div className="wl-header__left">
            <h1 className="wl-header__title">My Wishlist</h1>
            <p className="wl-header__sub">Courses you want to learn next</p>
          </div>
          <div className="wl-header__right">
            <div className="wl-stat">
              <span className="wl-stat__val">{courses.length}</span>
              <span className="wl-stat__label">Saved</span>
            </div>
            <div className="wl-stat wl-stat--ai">
              <span className="wl-stat__val">{avgMatch}%</span>
              <span className="wl-stat__label">Avg Match</span>
            </div>
          </div>
        </div>

        {/* ── INSIGHT BANNER ───────────────────────────────────────────── */}
        <div className="wl-insight-banner">
          <div className="wl-insight-banner__glow" />
          <Icon.Brain />
          <p>
            <strong>You are closest to React mastery path.</strong>
            {" "}Enrolling in Advanced React Patterns would push you from 65% to projected 90% proficiency.
          </p>
          <span className="wl-insight-banner__badge">AI Insight</span>
        </div>

        {/* ── CONTROL BAR ──────────────────────────────────────────────── */}
        <div className="wl-controls">
          <div className="wl-controls__left">
            <div className="wl-search">
              <Icon.Search />
              <input
                className="wl-search__input"
                placeholder="Search courses, instructors, tags..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
              {search && <button className="wl-search__clear" onClick={() => setSearch("")}><Icon.Close /></button>}
            </div>
            <button className={`wl-filter-toggle ${showFilters ? "wl-filter-toggle--active" : ""}`} onClick={() => setShowFilters(o => !o)}>
              <Icon.Filter />Filters{showFilters ? <Icon.ChevronDown /> : <Icon.ChevronRight />}
            </button>
          </div>
          <div className="wl-controls__right">
            <div className="wl-sort">
              <select className="wl-sort__select" value={sortBy} onChange={e => setSortBy(e.target.value)}>
                <option value="saved">Recently saved</option>
                <option value="rating">Top rated</option>
                <option value="match">Best match</option>
                <option value="priority">Priority</option>
              </select>
              <Icon.ChevronDown />
            </div>
            <ViewSwitcher view={view} onChange={v => { setView(v); if (v !== "focus") setSelected(null); }} />
          </div>
        </div>

        {/* ── FILTER PANEL ─────────────────────────────────────────────── */}
        {showFilters && (
          <div className="wl-filter-panel">
            <div className="wl-filter-group">
              <span className="wl-filter-group__label">Level</span>
              {["all", "beginner", "intermediate", "advanced"].map(l => (
                <button key={l} className={`wl-filter-chip ${filterLevel === l ? "wl-filter-chip--active" : ""}`} onClick={() => setFilterLevel(l)}>
                  {l === "all" ? "All levels" : l.charAt(0).toUpperCase() + l.slice(1)}
                </button>
              ))}
            </div>
            <div className="wl-filter-group">
              <span className="wl-filter-group__label">Priority</span>
              {["all", "high", "later", "maybe"].map(p => (
                <button key={p} className={`wl-filter-chip ${filterPriority === p ? "wl-filter-chip--active" : ""}`} onClick={() => setFilterPriority(p)}>
                  {p === "all" ? "All" : PRIORITY_CONFIG[p]?.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* ── CONTENT ──────────────────────────────────────────────────── */}
        {filtered.length === 0 ? (
          <EmptyState />
        ) : (
          <div className={`wl-content wl-content--${view}`}>

            {/* LIST VIEW */}
            {view === "list" && (
              <div className="wl-list">
                {filtered.map((c, i) => (
                  <div key={c.id} style={{ animationDelay: `${i * 0.05}s` }} className="wl-list__item">
                    <WishlistRow
                      course={c}
                      selected={selected?.id === c.id}
                      onSelect={handleSelect}
                      onRemove={handleRemove}
                      onPriorityChange={handlePriorityChange}
                    />
                  </div>
                ))}
              </div>
            )}

            {/* GRID VIEW */}
            {view === "grid" && (
              <div className="wl-grid">
                {filtered.map((c, i) => (
                  <div key={c.id} style={{ animationDelay: `${i * 0.07}s` }} className="wl-grid__item">
                    <WishlistCard
                      course={c}
                      onSelect={handleSelect}
                      onRemove={handleRemove}
                      onPriorityChange={handlePriorityChange}
                    />
                  </div>
                ))}
              </div>
            )}

            {/* FOCUS VIEW */}
            {view === "focus" && (
              <div className="wl-focus">
                {/* Left: compact list */}
                <div className="wl-focus__list">
                  {filtered.map(c => (
                    <div
                      key={c.id}
                      className={`wl-focus__item ${selected?.id === c.id ? "wl-focus__item--active" : ""}`}
                      onClick={() => setSelected(c)}
                      style={{ "--accent": c.accentColor }}
                    >
                      <div className="wl-focus__item-bar" />
                      <div className="wl-focus__item-body">
                        <div className="wl-focus__item-top">
                          <h4 className="wl-focus__item-title">{c.title}</h4>
                          <LevelBadge level={c.level} />
                        </div>
                        <div className="wl-focus__item-meta">
                          <StarRating rating={c.rating} />
                          <SavedAgo days={c.savedDaysAgo} />
                        </div>
                        <AiChip reason={c.aiReason} insight={c.aiInsight} />
                      </div>
                      <div className="wl-focus__item-chevron"><Icon.ChevronRight /></div>
                    </div>
                  ))}
                </div>

                {/* Right: preview panel */}
                <div className="wl-focus__panel">
                  {selected ? (
                    <PreviewPanel
                      course={selected}
                      onClose={() => setSelected(null)}
                      onRemove={handleRemove}
                      asModal={false}
                    />
                  ) : (
                    <div className="wl-focus__empty">
                      <Icon.Focus />
                      <p>Select a course to preview</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* GRID VIEW MODAL PREVIEW */}
        {view === "grid" && selected && (
          <PreviewPanel
            course={selected}
            onClose={() => setSelected(null)}
            onRemove={handleRemove}
            asModal={true}
          />
        )}
      </div>
    </MyStudentLayout>
  );
}